module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }